import {HttpErrorResponse} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import {EMPTY, Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {AuthApiService} from '../api/auth.api.service';
import {ResetPasswordRequest} from '../models/auth.model';
import {AuthStore} from '../store/auth.store';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly authApi = inject(AuthApiService);
  private readonly authStore = inject(AuthStore);

  // Development SSO URL
  private readonly loginUrl = `${environment.authUrl}/login`;

  logout(): void {
    const wasAuthenticated = this.authStore.isAuthenticated();
    this.authStore.clearUser();

    const doRedirect = () => {
      window.location.href = `${this.loginUrl}?redirect=${encodeURIComponent(window.location.href)}`;
    };

    if (!wasAuthenticated) {
      doRedirect();
      return;
    }

    this.authApi.logout().subscribe({
      next: () => {
        doRedirect();
      },
      error: (error) => {
        doRedirect();
      }
    });
  }

  fetchProfile(): Observable<any> {
    return this.authApi.fetchProfile().pipe(
      tap(profile => {
        this.authStore.setUser(profile.data || profile);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const currentUrl = encodeURIComponent(window.location.href);

          window.location.href = `${this.loginUrl}?redirect=${currentUrl}`;

          // Stop the observable since the page is about to navigate away.
          return EMPTY;
        }

        return throwError(() => error);
      })
    );
  }

  resetPassword(data: ResetPasswordRequest): Observable<any> {
    return this.authApi.resetPassword(data).pipe(
      tap(response => {
        this.authStore.setUser(response.data || response);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const currentUrl = encodeURIComponent(window.location.href);

          window.location.href = `${this.loginUrl}?redirect=${currentUrl}`;

          // Stop the observable since the page is about to navigate away.
          return EMPTY;
        }

        return throwError(() => error);
      })
    );
  }
}